
import { CrudModel } from "../CrudModel";

export default {
  data() {
    return {
      readMode: true,
      renderKey: 0,
      unsavedDialogOpen: false,
      navIntentTo: null,
    };
  },
  props: {
    model: {
      type: CrudModel,
      required: true,
    },
    open: {
      type: Boolean,
      default: false,
    },
    modelLayoutId: {
      type: String,
      default: "",
    },
    showModelActions: {
      type: Boolean,
      default: false,
    },
    readmodeDefault: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
    },
    modelLayoutOpts: {
      type: Object,
      default: () => ({}),
    },
    isBrandNew: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    itemDeleted() {
      this.$emit("deleted", this.model);
      this.layout.navigateAfterDelete(() => this.closeModal());
    },

    itemSaved() {
      this.$emit("saved", this.model);
      // When no explicit navigateAfterSave target is configured, a modal save
      // should just close and leave the user on whatever list they opened it
      // from (e.g. My Cases vs. Submissions). Returning `false` marks this
      // fallback as terminal — without it, executeNavigateToDef treats the
      // undefined return as "no target" and falls through to a stray
      // router.go(-1), which desyncs with the modal's history.pushState and
      // bounces the user to /submissions.
      this.layout.navigateAfterSave(() => {
        this.closeModal();
        return false;
      });
    },

    itemReverted() {
      this.model.reset();
    },

    closeModal(confirmed) {
      if (this.shouldConfirmClose)
        if (confirmed !== true) {
          return (this.unsavedDialogOpen = true);
        } else {
          this.$emit("cancel-new", this.model.id);
        }

      this.$emit("close");

      setTimeout(() => {
        this.readMode = this.readmodeDefault;
        this.renderKey++;
      }, 300);
    },

    confirmUnsaved() {
      this.unsavedDialogOpen = false;
    },

    xOutModal() {
      if (this.isBrandNew) this.cancelEditMode();
      else this.closeModal();
    },

    cancelEditMode() {
      if (this.model.isNew) {
        this.$emit("cancel-new", this.model.id);
        this.$emit("close");
      } else {
        this.model.reset();
        this.readMode = true;
      }
    },
    confirmNav() {
      this.unsavedDialogOpen = false;
      this.closeModal(true);

      if (this.navIntentTo) this.$router.push(this.navIntentTo);
    },
    cancelNav() {
      this.navIntentTo = null;
      this.unsavedDialogOpen = false;
    },
    gotoEditPage() {
      // If the route is the same, replace it to trigger reactivity but avoid duplicate history entry
      return this.$router.replace({ path: this.singleLink });
    },

    unloadListener(e) {
      if (this.shouldConfirmClose) {
        if (
          !window.confirm(
            "You have unsaved changes. Do you want to continue to leave this page?"
          )
        ) {
          e.preventDefault();
          e.returnValue = "";
        }
      }
    },
  },
  computed: {
    readModeTogglable() {
      return !this.model.isReadonlyToUser();
    },
    typeLabel() {
      return this.model.typeLabel;
    },
    layout() {
      const layout = this.model.getModelLayout(this.modelLayoutId);

      return layout.newForModel(this.model, this.modelLayoutOpts);
    },
    singleLink() {
      return this.model.getRouteSingle();
    },
    shouldConfirmClose() {
      return (
        !this.model.isValid ||
        (this.model.hasUnsavedChanges &&
          this.showModelActions &&
          !this.model.wasJustSaved)
      );
    },
  },
  watch: {
    model: {
      immediate: true,
      handler: function () {
        if (this.model.isNew) this.readMode = false;
        else this.readMode = this.readmodeDefault;
      },
    },
    open: {
      immediate: true,
      handler: function () {
        if (this.open) {
          if (this.model.isNew) this.readMode = false;
          window.addEventListener("beforeunload", this.unloadListener);
        } else {
          window.removeEventListener("beforeunload", this.unloadListener);
        }
      },
    },
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.unloadListener);
  },
};
